<template>
    <el-dialog
        class="center-dialog city-check-dialog"
        title="请选择城市"
        :visible="value"
        @update:visible="handleVisibleChange"
        width="786px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <div class="dialog-box">
            <div class="tab-header flex-center">
                <div
                    :class="['tab-item flex-center', { active: currentTab === tab.value }]"
                    v-for="tab in tabList"
                    :key="tab.value"
                    @click="currentTab = tab.value"
                >
                    {{ tab.label }}
                </div>
            </div>

            <div class="check-list">
                <!-- 热门城市 -->
                <div class="list-box" v-if="currentTab === 'hot'">
                    <div
                        :class="['check-item', { active: checked === item.value }]"
                        v-for="item in hotCityList"
                        :key="item.value"
                        @click="handleCheck(item)"
                    >
                        <div class="ellipsis-single">{{ item.label }}</div>
                    </div>
                </div>

                <!-- 字母排序，二级列表 -->
                <div class="list-second-box" v-else>
                    <div class="second-item flex-center" v-for="check in groupList" :key="check.label">
                        <span class="label">{{ check.label }}</span>

                        <div class="second-check">
                            <div
                                :class="['check-item', { active: checked === option.value }]"
                                v-for="option in check.options"
                                :key="option.value"
                                @click="handleCheck(option)"
                            >
                                <div class="ellipsis-single">{{ option.label }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import cityJSON from "@/json/city.json";
export default {
    data() {
        return {
            currentTab: "hot",
            tabList: [
                { label: "热门城市", value: "hot" },
                { label: "ABCDE", value: "ABCDE" },
                { label: "FGHJ", value: "FGHJ" },
                { label: "KLMN", value: "KLMN" },
                { label: "PQRST", value: "PQRST" },
                { label: "WXYZ", value: "WXYZ" },
            ],

            cityGroup: cityJSON.cityGroup,
            hotCityList: cityJSON.hotCityList,
        };
    },

    model: {
        prop: "value",
        event: "input",
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },

        check: {
            type: String,
            default: "",
        },
    },

    computed: {
        checked() {
            return !this.check ? "全国" : this.check;
        },

        groupList() {
            const codes = this.currentTab.split("");
            const list = [];

            codes.forEach((code) => {
                list.push({
                    label: code,
                    options: this.cityGroup[code] ?? [],
                });
            });

            return list;
        },
    },

    methods: {
        handleVisibleChange(val) {
            this.$emit("input", val);

            if (!val) {
                this.currentTab = "hot";
            }
        },

        handleCheck(val) {
            if (this.check === val.value) return;

            this.$emit("check", val);
            this.handleVisibleChange(false);
        },
    },
};
</script>

<style lang="scss" scoped>
.dialog-box {
    height: 410px;
    display: flex;
    flex-direction: column;

    .tab-header {
        height: 40px;
        background-color: #f9fafb;

        .tab-item {
            flex: 1;
            min-width: 0;
            height: 100%;
            position: relative;
            cursor: pointer;

            &::after {
                content: "";
                position: absolute;
                width: 50%;
                height: 2px;
                background-color: #685ef5;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                display: none;
            }

            &.active {
                color: #685ef5;

                &::after {
                    display: block;
                }
            }

            &:hover {
                color: #685ef5;
            }
        }
    }

    .check-list {
        flex: 1;
        min-height: 0;
        overflow: auto;
        padding-top: 16px;

        .check-item {
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #414a60;
            border-radius: 4px;
            cursor: pointer;
            min-width: 0;

            &:hover,
            &.active {
                color: #685ef5;
                // background-color: rgba(104, 94, 245, 0.1);
            }
        }

        .list-box {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            row-gap: 8px;
        }

        .list-second-box {
            .second-item {
                align-items: flex-start;
                font-size: 14px;

                .label {
                    display: inline-block;
                    height: 40px;
                    line-height: 40px;
                    color: #685ef5;
                    text-align: center;
                    width: 90px;
                }

                .second-check {
                    flex: 1;
                    min-height: 0;
                    display: grid;
                    grid-template-columns: repeat(5, 1fr);
                    row-gap: 8px;
                }

                & + .second-item {
                    margin-top: 16px;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.city-check-dialog {
    .el-dialog__body {
        padding-inline: 0;
        padding-bottom: 0;
    }
}
</style>
